import * as React from 'react';
import { cn } from '@reflex/ui/lib/utils';
export type InteractiveAvatarProps = {
  className?: string;
  title?: string;
  'aria-label'?: string;
  children: React.ReactNode;
  to?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit';
};
export const InteractiveAvatar = React.forwardRef<HTMLElement, InteractiveAvatarProps>(
  function InteractiveAvatar({ className, children, to, onClick, type = 'button', ...rest }, ref) {
    const classes = cn(
      // Keep the affordance inside the avatar's box. Transcript rows use
      // content-visibility paint containment, so an outward ring is clipped
      // when the avatar sits flush against the row's left edge.
      'inline-flex rounded-full transition-shadow hover:ring-2 hover:ring-inset hover:ring-ring/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/60',
      className,
    );
    if (to)
      return (
        <a href={to} ref={ref as React.Ref<HTMLAnchorElement>} className={classes} {...rest}>
          {children}
        </a>
      );
    return (
      <button
        type={type}
        ref={ref as React.Ref<HTMLButtonElement>}
        onClick={onClick}
        className={classes}
        {...rest}
      >
        {children}
      </button>
    );
  },
);
